import React, {useEffect, useState} from "react";
import {VISITOR_MODEL} from "../Model/Model";
import HandleChange from "../../../../Helpers/HandleChange";
import {useTranslation} from "react-i18next";
import {errorMsg, isEmailFormat, isPhoneFormat, userListToLabelEmailPhoneValue} from "../../../../Apis/functions";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {preRegisterUser} from "../../../../reduxToolkit/Visitor/VisitorApi";
import ButtonIcon from "../../../../components/buttons/ButtonIcon";
import {CleanIcon, PersonChipBlack} from "../../../../components/buttons/IconButtons";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * @param {function} setModified - Optional callback to indicate that a modification has been made after a visitor is created.
 * @param {function} [onHide=() => {}] - Function to close or hide the modal. Defaults to an empty function.
 * @param {function} setSelectedList - Callback to set the selected visitor(s) list after creation.
 * @param list selectedList: list of selected visitors
 */

export const CreateVisitorModalApp =({ setModified, onHide = () => {}, setSelectedList ,
                                         selectedList, dataVisitor=null, selectVisitorType=false, afterCreate })=>{
    const [userData, setUserData] = useState({...VISITOR_MODEL});
    const [emptyFields, setEmptyFields] = useState(false);
    const { handleChange } = HandleChange({ model: userData, setModel: setUserData });
    const {t} = useTranslation();
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
    const dispatch = useDispatch();
    const allVisitorTypes = useSelector((state) => state?.EmployeeEventsSlice?.getAllVisitorTypes);
    const [disabled, setDisabled] = useState(false);
    /**
     * If you receive the Visitor data object with the visitor/user information, set the userData variable.
     * This happens when you only want to select the visitor type but return the same object.
     */
    useEffect(() => {
        if (dataVisitor?.id || dataVisitor?.userId){
            setDisabled(true);
            setUserData({...userData.setSimple(dataVisitor)});
        }
    }, [dataVisitor]);

    const handleClear = () => {
        setUserData({...userData.clear()});
        setEmptyFields(false);
        setIsValidEmail(true);
        setIsValidPhoneNumber(true);
    };

    const handleClose = () => {
        handleClear();
        onHide();
    };

    const clearButton = () => {
        return (
            <ButtonIcon
                id='btn_cvi_clean'
                Icon={CleanIcon}
                onClick={handleClear}
                title={'clear_instances'}
                className={"btn-clean-secondary-600"}
                tooltipPlacement={"right"}
                iconProps='btn-icon-svg-12px icon-color-general-00'
            />
        )
    }

    const handleEmailChange = (email) => {
        validateEmail(email);
    };

    const handlePhoneNumberChange = (phone, setUser) => {
        setUser((prevData) => ({
            ...prevData,
            phoneNumber: phone !== '' ? '+' + phone : '',
        }));
        validatePhone(phone);
    };

    const validateEmail = (email) => {
        setIsValidEmail(isEmailFormat(email));
    };

    const validatePhone = (phone) => {
        setIsValidPhoneNumber(isPhoneFormat(phone));
    };

    const handleCreate = () => {
        const noValidVisitorType = !userData?.visitorTypeId;

        if (!userData?.isValid() || (selectVisitorType === true && noValidVisitorType )) {
            setEmptyFields(true);
            return;
        }
        if(!isValidEmail || !isValidPhoneNumber) return;

        if(dataVisitor?.id || dataVisitor?.userId){
            if (noValidVisitorType) {
                setEmptyFields(true);
                return;
            }
            setEmptyFields(false);
            if(setSelectedList) setSelectedList([...selectedList, ...userListToLabelEmailPhoneValue([userData], 'userId', true, PersonChipBlack)]);
            handleClear();
            onHide();
            return;
        }
        const body = userData.toRegister();

        dispatch(preRegisterUser(body))
            .then(({ payload: { data: { success, code, data }}}) => {
                if (success) {
                    const userDataArray = Array.isArray(data) ? data : [data];
                    const updatedUserDataArray = userDataArray.map(user => ({
                        ...user,
                        visitorTypeId: userData?.visitorTypeId || null
                    }));
                    if(setSelectedList) setSelectedList([...selectedList, ...userListToLabelEmailPhoneValue(updatedUserDataArray, 'id', true, PersonChipBlack)]);
                    handleClear()
                    toast.success(t('has_been_created_successfully'));
                    if(afterCreate) afterCreate(data);
                    if(setModified) setModified(true)
                    onHide()
                } else errorMsg(code);
            })
        setEmptyFields(false);
    };

    return {
        handleClear,
        userData,
        handleChange,
        emptyFields,
        isValidEmail,
        isValidPhoneNumber,
        handleCreate,
        handleClose,
        handleEmailChange,
        handlePhoneNumberChange,
        setUserData,
        clearButton,
        allVisitorTypes,
        disabled
    }
}
